export enum PlayerPosition {
    ATF = 'ATF',
    MTF_CONTENT = 'MTF_CONTENT',
    BTF = 'BTF'
}
